import { render, staticRenderFns } from "./SetupPlanSokol.vue?vue&type=template&id=c26d61f4&scoped=true"
import script from "./SetupPlanSokol.vue?vue&type=script&lang=js"
export * from "./SetupPlanSokol.vue?vue&type=script&lang=js"
import style0 from "./SetupPlanSokol.vue?vue&type=style&index=0&id=c26d61f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26d61f4",
  null
  
)

export default component.exports